export class Province {
    provinceId: number;
    displayName: string;
    cityId:number;
}